<template>
  <modal :showModal="showModal" id="modal-tranches" @close="close">
    <template slot="modal-header">
      <h5 class="bold">Zmień status transzy</h5>
    </template>

    <template slot="modal-body">
      <div class="col s12 left-align token-value">Token: <span>{{ tranche.token }}</span></div>
      <div class="col s12 left-align amount-value">Wartość: <span>{{ tranche.amount | currency }}</span></div>
      <div class="col s12 left-align email-value">User email: <span>{{ tranche.account.email }}</span></div>
      <div class="col s12 status-change-value">
        <select class="browser-default" v-model="status">
          <option v-for="s in getStatuses" :value="s.value">{{ s.name }}</option>
        </select>
      </div>
    </template>

    <template slot="modal-footer">
      <button class="btn btn-large btn-first" @click="changeStatus()">
        <i class="mfind-icon-save"></i>
        Zapisz
      </button>
      <button class="btn btn-large btn-secondary" @click="close">
        <i class="mfind-icon-back"></i>
        Zamknij
      </button>

      <transition name="slide-fade" mode="in-out">
        <div v-if="data.errors" class="error center-align validation-errors">
          <span class="red-text" v-if="data.errors['message']">{{ data.errors['message'].join(', ') }}</span>
          <span class="red-text" v-else>Coś poszło nie tak, skontaktuj się z nami.</span>
        </div>
      </transition>
    </template>

    <template slot="loader">
      <Loader :loading="this.data.loading"/>
    </template>
  </modal>
</template>

<script>
import Materialize from 'materialize-css'
import Loader from '@/components/loader'
import Modal from '@/components/modal'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('tranches')
export default {
  props: ['tranche', 'showModal', 'currentStatus'],
  components: { Loader, Modal },
  data () {
    return {
      status: `${this.currentStatus}`,
      data: {
        loading: false,
        errors: false
      }
    }
  },
  methods: {
    close: function () {
      this.$emit('close')
    },
    changeStatus: function () {
      this.data.errors = false
      this.data.loading = true
      this.$store.dispatch('tranches/changeTrancheStatus', {
        'tranch_id': this.tranche.id,
        'status': this.status
      })
        .then(
          response => {
            if (response.code === 200) {
              this.data.loading = false
              Materialize.toast(response.data.message, 4000)
              this.$emit('reloadTranches')
              this.close()
            }
          },
          errorResponse => {
            this.data.errors = errorResponse.errors
            this.data.loading = false
          }
        )
    }
  },
  computed: {
    ...mapGetters([
      'getStatuses'
    ])
  }
}
</script>

<style lang="scss">
@import 'src/components/modal';

.token-value, .amount-value, .email-value, .status-change-value {
  margin: 5px 0;

  span {
    font-weight: bold;
  }
}
.status-change-value {
  margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// modalTranche.vue?49baf857